import { z } from "zod";

import { userSchema } from "../../user/userSchema";

export const promptResponseSchema = z.object({
  id: z.number(),
  text: z.string(),
  user: userSchema,
});

export type PromptResponse = z.infer<typeof promptResponseSchema>;
